/**
 * List of all event types with Swedish labels (single source of truth)
 */
export const eventTypes = [
    { value: 'USER_LOGIN', label: 'Inloggning' },
    { value: 'USER_LOGOUT', label: 'Utloggning' },
    { value: 'USER_CREATED', label: 'Användare skapad' },
    { value: 'USER_UPDATED', label: 'Användare uppdaterad' },
    { value: 'USER_DELETED', label: 'Användare borttagen' },
    { value: 'ORGANIZATION_CREATED', label: 'Organisation skapad' },
    { value: 'ORGANIZATION_UPDATED', label: 'Organisation uppdaterad' },
    { value: 'ORGANIZATION_DELETED', label: 'Organisation borttagen' },
    { value: 'CARE_UNIT_CREATED', label: 'Vårdenhet skapad' },
    { value: 'CARE_UNIT_UPDATED', label: 'Vårdenhet uppdaterad' },
    { value: 'CARE_UNIT_DELETED', label: 'Vårdenhet borttagen' },
    { value: 'OPTICIAN_SHOP_CREATED', label: 'Optiker skapad' },
    { value: 'OPTICIAN_SHOP_UPDATED', label: 'Optiker uppdaterad' },
    { value: 'OPTICIAN_SHOP_DELETED', label: 'Optiker borttagen' },
    { value: 'OPTICIAN_SHOP_UNLINKED', label: 'Optiker bortkopplad' },
    { value: 'OPTICIAN_SHOP_LINKED', label: 'Optiker kopplad' },
    { value: 'REFERRAL_TRANSMISSION_SUCCESS', label: 'Remiss skickad' },
    { value: 'REFERRAL_TRANSMISSION_FAILED_CLIENT', label: 'Klientfel' },
    { value: 'REFERRAL_TRANSMISSION_FAILED_SERVER', label: 'Serverfel (remissleverantör)' },
    { value: 'REFERRAL_TRANSMISSION_FAILED_REST_CLIENT', label: 'Kommunikationsfel' },
    { value: 'REFERRAL_DETAILS_VIEWED', label: 'Remiss öppnad' },
    { value: 'REFERRAL_STATUS_REFRESHED', label: 'Remisstatus uppdaterad' },
]

/**
 * Get Swedish label for event type (derives from eventTypes array)
 */
export const eventTypeLabel = (t) =>
    eventTypes.find(e => e.value === t)?.label || t || 'Okänd händelse'
